/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetAllComplianceViolations = require('../../compliance-dashboard/services/GetAllComplianceViolations');
var GetAllPrincipleLicenseTypes = require('../../compliance-dashboard/services/GetAllPrincipleLicenseTypes');
var GetEntityFlaggedStatus = require('../../entity-dashboard/services/GetEntityFlaggedStatus');

var NonDepEntityCreateComplianceCaseRequestView = require('../views/NonDepEntityCreateComplianceCaseRequestView');

module.exports = function(entityId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(
    GetEntityIdentifiers(entityId),
    GetAllPrincipleLicenseTypes(),
    GetAllComplianceViolations(),
    GetEntityFlaggedStatus(entityId)
  )
    .done(function(entityIdentifiers, licenseTypes, violationCodes, hasFlagged) {
      NavUtils.navigate('#nondep/entity/' + entityId + '/new-compliance');
      Scaffold.content.show(
        new NonDepEntityCreateComplianceCaseRequestView({
          model: new Backbone.Model({
            entityId: entityId,
            entityName: entityIdentifiers.entityName,
            entityIdentifiers: entityIdentifiers,
            licenseTypes: licenseTypes,
            violationCodes: violationCodes,
            hasFlagged: hasFlagged
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
